/**
 * @file
 * @fileOverview This file contains the SpeechSynthesizer class for handling speech synthesis.
 * @version 1.0.0
 * @author Parker Eli Bidigare
 * @date 2024-05-26
 */

class SpeechSynthesizer {
  constructor() {
    this.synth = window.speechSynthesis;
    this.voices = [];
    this.populateVoices();

    window.speechSynthesis.onvoiceschanged = () => {
      this.populateVoices();
    };
  }

  populateVoices() {
    this.voices = this.synth.getVoices();
  }

  speak(text, voiceName = null, pitch = 1, rate = 1) {
    if (this.synth.speaking) {
      console.error('SpeechSynthesis is already speaking.');
      return;
    }

    if (text !== '') {
      const utterance = new SpeechSynthesisUtterance(text);

      if (voiceName) {
        utterance.voice = this.voices.find((voice) => voice.name === voiceName);
      }
      utterance.pitch = pitch;
      utterance.rate = rate;

      utterance.onend = () => {
        console.log('SpeechSynthesisUtterance.onend');
      };

      utterance.onerror = (event) => {
        console.error('SpeechSynthesisUtterance.onerror', event);
      };

      this.synth.speak(utterance);
    }
  }

  pause() {
    if (this.synth.speaking && !this.synth.paused) {
      this.synth.pause();
    }
  }

  resume() {
    if (this.synth.paused) {
      this.synth.resume();
    }
  }

  cancel() {
    this.synth.cancel();
  }

  getVoices() {
    return this.voices;
  }
}

export default SpeechSynthesizer;
